export interface CustomChatTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomChatTabPanel(props: CustomChatTabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

export default CustomChatTabPanel;
